import { Text } from '@chakra-ui/react'

export const Title: React.FC<{
  title?: string
  defaultTitle: string
}> = ({ title, defaultTitle }) => (
  <Text
    className="body-small-emphasis"
    color={!title ? 'graphite' : 'onyx'}
    data-testid={`itemCard-itemTitle`}
  >
    {title ? title : defaultTitle}
  </Text>
)

export default Title
